import { ReducerBuilder } from './reducerBuilder';
import { MenuState } from 'acscp/store';
import { SetOpenMenu } from 'acscp/actions';

export const menuReducer =
    new ReducerBuilder<MenuState>({
        currentlyOpenMenu: undefined
    })
        .actionCase(SetOpenMenu, (state, action) => ({
            currentlyOpenMenu: action.menu
        }))
        .build();
